module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toggleable-button"
  }, [_c('button', {
    class: _vm.buttonClass,
    attrs: {
      "disabled": _vm.disabled,
      "value": _vm.value
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6efa618a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/ToggleableButton.vue
// module id = 2575
// module chunks = 1